import {observer} from "mobx-react";
import {useStore} from "../../../../../../../hooks";
import Alerts from "../../../../../../../elements/v2/Alerts/Alerts";
import {MarketingErrorMessages} from "../../../../../../../utils/enums";
import React from "react";

export const AgentSelectionAlert = observer(() => {
  const { marketingStore } = useStore();
  const { alert } = marketingStore;

  return (
    <>
      {alert.showAgentSelection && (
        <Alerts
          severity={"error"}
          width={"auto"}
          top={"61px"}
          right={"16px"}
          title={MarketingErrorMessages.PREVENT_PUBLISH_WITHOUT_AGENT.title}
          message={MarketingErrorMessages.PREVENT_PUBLISH_WITHOUT_AGENT.message}
          onClose={() => alert.showOrHide("showAgentSelection")}
        />
      )}
    </>
  );
});
